export const reportCheckListFilter = {
  data: function () {
    return {
      checkListFilter: {
        showPreviousDepartures: false,
        currentDone: 'any',
        currentRequired: 'any',
        prevDone: 'any',
        prevRequired: 'any'
      },
      checkListContractorFilter: {
        showPreviousDepartures: false,
        currentDone: 'any',
        currentRequired: 'any',
        prevDone: 'any',
        prevRequired: 'any'
      }
    }
  },
  computed: {
    filteredWorkTypes: function () {
      return this.filterWorkTypes(this.report.workTypes, this.checkListFilter)
    },
    filteredWorkPackages: function () {
      return this.filterWorkPackages(this.report.workPackages, this.checkListFilter)
    },
    filteredWorkTypesContractor: function () {
      return this.filterWorkTypes(this.report.workTypesContractor, this.checkListContractorFilter)
    },
    filteredWorkPackagesContractor: function () {
      return this.filterWorkPackages(this.report.workPackagesContractor, this.checkListContractorFilter)
    }
  },
  watch: {
    checkListFilter: {
      handler (newValue) {
        localStorage.setItem('checkListFilter', JSON.stringify(newValue))
      },
      deep: true
    },
    checkListContractorFilter: {
      handler (newValue) {
        localStorage.setItem('checkListContractorFilter', JSON.stringify(newValue))
      },
      deep: true
    }
  },
  created: function () {
    const savedFilter = localStorage.getItem('checkListFilter')
    if (savedFilter && !this.showMobileView) {
      this.checkListFilter = {
        ...this.checkListFilter,
        ...JSON.parse(savedFilter)
      }
    }
    const savedContractorFilter = localStorage.getItem('checkListContractorFilter')
    if (savedContractorFilter && !this.showMobileView) {
      this.checkListContractorFilter = {
        ...this.checkListContractorFilter,
        ...JSON.parse(savedFilter)
      }
    }
  },
  methods: {
    filterWorkTypes: function (workTypes, filter) {
      let workTypesCurrentReport = workTypes.filter(workType => workType.includedInCurrentReport)
      let workTypesPreviousReport = filter.showPreviousDepartures ? workTypes.filter(workType => !workType.includedInCurrentReport) : []

      const filterDone = function (workTypes, filterDoneValue) {
        if (filterDoneValue === 'any') {
        } else if (filterDoneValue === 'yes') {
          workTypes = workTypes.filter(workType => workType.done)
        } else if (filterDoneValue === 'yesOrPartial') {
          workTypes = workTypes.filter(workType => workType.donePartially || workType.done)
        } else if (filterDoneValue === 'onlyPartial') {
          workTypes = workTypes.filter(workType => workType.donePartially && !workType.done)
        } else if (filterDoneValue === 'noOrPartial') {
          workTypes = workTypes.filter(workType => !workType.done || workType.donePartially && !workType.done)
        } else if (filterDoneValue === 'no') {
          workTypes = workTypes.filter(workType => !workType.done && !workType.donePartially)
        }
        return workTypes
      }

      const filterRequired = function (workTypes, filterRequiredValue) {
        if (filterRequiredValue === 'any') {
        } else if (filterRequiredValue === 'yes') {
          workTypes = workTypes.filter(workType => workType.required)
        } else if (filterRequiredValue === 'no') {
          workTypes = workTypes.filter(workType => !workType.required)
        }
        return workTypes
      }

      workTypesCurrentReport = filterDone(workTypesCurrentReport, filter.currentDone)
      workTypesCurrentReport = filterRequired(workTypesCurrentReport, filter.currentRequired)
      workTypesPreviousReport = filterDone(workTypesPreviousReport, filter.prevDone)
      workTypesPreviousReport = filterRequired(workTypesPreviousReport, filter.prevRequired)

      return [...workTypesCurrentReport, ...workTypesPreviousReport]
    },
    filterWorkPackages: function (workPackages, filter) {
      const filteredWorkPackages = workPackages.map(workPackage => {
        const filteredTypes = this.filterWorkTypes(workPackage.workTypes, filter)
        return Object.assign({}, workPackage, { workTypes: filteredTypes })
      })

      return filteredWorkPackages.filter(workPackage => workPackage.workTypes.length > 0)
    }
  }
}
